import React from 'react';

import { InvitationList } from '@components/utilities/Friend/InvitationList';

export const InvitationsSent: React.FC = () => <InvitationList role="requester" />;
